import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOutlinedPlusIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.22607 11.9998H16.7735", stroke: "#333333", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.0005 7.19995V16.8", stroke: "#333333", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgOutlinedPlusIcon);
const Memo = memo(ForwardRef);
export default Memo;
